import { MenuItem, MenuSeparator } from '@headlessui/react';
import Link from 'next/link';

import { UserNavLink } from '../config';

export function HeaderMenuItem(
	props: UserNavLink & { onNavigate?: () => void },
) {
	if (!props.name) {
		return <MenuSeparator className="my-1 h-px bg-gray-100" />;
	}
	if (!props.href) {
		return (
			<MenuItem>
				<span className="block px-4 py-2 text-sm">{props.name}</span>
			</MenuItem>
		);
	}
	// Если в hint есть ссылки, не делаем основной элемент ссылкой
	const hasLinksInHint = typeof props.hint === 'object' && props.hint;

	if (hasLinksInHint) {
		return (
			<MenuItem>
				<div className="block rounded-lg px-3 py-2 text-sm data-[focus]:bg-gray-5 data-[selected]:bg-gray-5">
					<div className="font-medium">{props.name}</div>
					{props.hint && (
						<small className="block text-gray-3">{props.hint}</small>
					)}
				</div>
			</MenuItem>
		);
	}

	return (
		<MenuItem>
			<Link
				href={props.href!}
				onClick={props.onNavigate}
				className="block rounded-lg px-3 py-2 text-sm data-[focus]:bg-gray-5 data-[selected]:bg-gray-5"
				target={props.extended ? '_blank' : '_self'}
			>
				{props.name}
				{props.hint && (
					<small className="block text-gray-3">{props.hint}</small>
				)}
			</Link>
		</MenuItem>
	);
}
